import React, { useContext, useState } from 'react';
import { TopNavigation } from 'vitl-component-library';
import { navigate } from 'gatsby';

import { GlobalContext } from '@store/global-state';
import useLogoutUser from '@hooks/useLogoutUser';

interface IProps {
  siteTitle: string;
}

const TopNavigationComponent = ({ siteTitle }: IProps) => {
  const { isLoggedIn, sidebar, setSidebar } = useContext(GlobalContext);
  const logo = { filename_disk: '3a5b9088-781c-4654-b9cf-e7f6e412bd01.svg' };

  const [windowIsScrolled, setWindowIsScrolled] = useState(false);
  const [showStickyNav, setShowStickyNav] = useState<boolean>(false);

  const bannerHeight = 0;

  const navigateTo = (path: string) => {
    navigate(`${process.env.GATSBY_VITL_HOST_NAME}${path}`);
  };

  return (
    <TopNavigation
      logo={logo}
      siteTitle={siteTitle}
      rootUrl={process.env.GATSBY_VITL_HOST_NAME || ''}
      bannerHeight={bannerHeight}
      showStickyNav={showStickyNav}
      setShowStickyNav={setShowStickyNav}
      windowIsScrolled={windowIsScrolled}
      setWindowIsScrolled={setWindowIsScrolled}
      showShopModal={false}
      isLoggedIn={isLoggedIn}
      sidebar={sidebar}
      showCart={false}
      setShowCart={() => console.log('setShowCart')}
      setSidebar={setSidebar}
      isPrivateRoute={false}
      useLogoutUser={useLogoutUser}
      hideSearch={true}
      useSearch={() => null}
      navigateTo={navigateTo}
      setShowAddCoupon={() => console.log('setShowAddCoupon')}
      dataCart={undefined}
      loadingCart={false}
      shouldClearCart={() => true}
      location={''}
    />
  );
};

export default TopNavigationComponent;
